// ** React Imports
import { useMemo } from "react";

// ** Redux & Store & Actions
import { useSelector } from "react-redux";

// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Custom Components
import { ButtonLanding } from "components/layout/Button/ButtonLanding";

// #####################################################

const PrevButton = ({ ...props }) => {
	const { t } = useTranslation(["common", "landing"]);

	const language = useSelector((state) => state.globalCommon.language);

	const prevButtonText = useMemo(() => {
		const text = t("landing:register.back");
		return text;
	}, [language]);

	// #####################################################

	return (
		<ButtonLanding $outline {...props}>
			{prevButtonText}
		</ButtonLanding>
	);
};

// #####################################################

export default PrevButton;

// #####################################################
